export default __webpack_public_path__ + "static/media/hotel-icon.e43bd17e.svg";